export const formatAmountPrice = (amount) => {
  const formattedAmount = new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'XOF',
    minimumFractionDigits: 0, // Set to 0 if you don't want to show decimal places
    maximumFractionDigits: 2  // Set to 2 if you want to show two decimal places
  }).format(amount);

  return formattedAmount
}